import { merge } from './merge';


function getStopsPromise(component, serviceId) {
    let promise;
    if (serviceId) {
        promise = component.props.unRideIt.getStops(serviceId).then((stopsRes) => {
            return {
                "stops": stopsRes.data
            }
        });
    } else {
        promise = Promise.resolve({
            "stops": []
        });
    }

    return promise
}

function getLinestringsPromise(component, networkId) {
    let promise;
    if (networkId) {
        promise = component.props.unRideIt.getLinestrings(networkId).then((res) => {
            return {
                "linestrings": res.data
            }

        });
    } else {
        promise = Promise.resolve({
            "linestrings": []
        });
    }

    return promise;
}

function getRoutesForRoutingsPromise(component, networkId) {
    let promise;
    if (networkId) {
        promise = component.props.unRideIt.getRoutesForRoutings(networkId).then((res) => {
            return {
                "routesForRoutings": res.data
            }
        });
    } else {
        promise = Promise.resolve({

            "routeForRoutings": {}
        });
    }

    return promise;
}

export function setNetwork(component, networkId) {
    Promise.all([getRoutesForRoutingsPromise(component, networkId), getLinestringsPromise(component, networkId)])
        .then((states) => {
            const newState = merge(states)
            component.setState(newState)
        });
}

